export enum ConnectorRequestStateEnum {
    pending = 'Pending',
    completed = 'Completed',
    failed = 'Failed'
}